export default "__VITE_ASSET__62157b09__"